module.exports = __webpack_public_path__ + "static/integra-blog3-c87fe974752f0f07206b1595dbc8f46c.png";